import { ActionCreatorWithPayload, ActionCreatorWithoutPayload, createAction } from "@reduxjs/toolkit";

import { LocalError, NetworkError, SocketError } from "~/app/error/error.store";

const setNetworkErrorAction: ActionCreatorWithPayload<NetworkError> = createAction("error/set-network");

const setLocalErrorAction: ActionCreatorWithPayload<LocalError> = createAction("error/set-local");

const setSocketErrorAction: ActionCreatorWithPayload<SocketError> = createAction("error/set-socket");

const resetErrorAction: ActionCreatorWithoutPayload = createAction<void>("error/reset");

export default {
  setNetworkErrorAction,
  setLocalErrorAction,
  setSocketErrorAction,
  resetErrorAction
};
